module.exports = __webpack_public_path__ + "static/media/3.4c8c418f.jpg";